import { uploadFile } from '../api'
import { Modal } from 'antd-mobile'
const alert = Modal.alert

class Uploader {
  private inputDom: HTMLInputElement
  private inputCallback: InputCallback

  constructor(inputCallback: InputCallback) {
    this.inputDom = this.initInputDom()
    this.inputCallback = inputCallback
  }

  private initInputDom() {
    var u = navigator.userAgent
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端

    const inputDom = document.createElement('input')
    inputDom.id = 'uploader'
    inputDom.setAttribute('type', 'file')
    inputDom.multiple = true
    isAndroid && inputDom.setAttribute('capture', 'camera')
    inputDom.style.visibility = 'hidden'
    inputDom.style.position = 'absolute'
    inputDom.style.bottom = '0px'

    document.body.appendChild(inputDom)

    // inputDom.addEventListener('input', this.upload.bind(this))

    // test this
    inputDom.addEventListener('change', this.upload.bind(this))

    return inputDom
  }

  getInputDom() {
    return this.inputDom
  }

  upload() {
    const files = this.inputDom.files
    if (!files) return

    let list = [...files],
      tooLarge = false

    if (this.inputDom.getAttribute('accept') === 'image/*') {
      list = list.filter((item) => {
        if (item.size > 10 * 1000 * 1000) {
          if (!tooLarge) {
            tooLarge = true
            alert('', '图片大小不能超过10M')
          }

          return false
        }
        return true
      })
    } else {
      list = list.filter((item) => {
        if (item.size > 300 * 1000 * 1000) {
          if (!tooLarge) {
            tooLarge = true
            alert('', '文件大小不能超过300M')
          }

          return false
        }
        return true
      })
    }

    if (list.length > 10) {
      alert('', '一次最多只能上传10个文件')
      list = list.slice(0, 10)
    }
    uploadFile(this.inputCallback(list))
    this.inputDom.value = ''
  }
}

export default Uploader
